import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const workplaceService = {
  getWorkplaces,
  create,
  removeUserFromWorkplace,
  remove,
  approveInviteRequest,
  rejectInviteRequest,
  updateRole,
  getWorkplaceList,
  inviteToWorkplace,
  getWorkplaceManageInvites,
  getWorkplaceSettings,
  updateWorkplace,
  getWorkplaceGroups,
  getWorkplaceSettingsMembers,
  getWorkplaceMembers,
  getLeadershipTeam,
  getRightsPermissions,
  removeWorkplaceMember,
  deleteWorkplace,
  deleteWorkplaceInvitation,
  getInvites,
  respondToInvite,
  sendInviteToNonWPMembers
}

function getWorkplaces(organizationId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/workplace/settings/workplace-list?organization_id=${organizationId}`, requestOptions)
}

function create(organizationId, name, location, color, contentRestriction) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: {
      organization_id: organizationId,
      name,
      location,
      color,
      content_restriction: contentRestriction
    }
  }
  return doRequestAxios(`/v2/workplace/create`, requestOptions)
}

function removeUserFromWorkplace(workplaceId, userId, dashboard, groupTransferData) {
  const params = {
    workplace_id: workplaceId,
    user_id: userId,
    dashboard
  }
  if (groupTransferData) {
    params.group_transfer_data = groupTransferData
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/workplace/member/remove`, requestOptions)
}

function remove(workplaceId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/workplace/delete?workplace_id=${workplaceId}`, requestOptions)
}

function approveInviteRequest(workplaceId, invitationIds) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      workplace_id: workplaceId,
      invitation_ids: invitationIds.toString()
    }
  }
  return doRequestAxios(`/v2/workplace/invitations-from-entity/accept`, requestOptions)
}

function rejectInviteRequest(workplaceId, invitationIds) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      workplace_id: workplaceId,
      invitation_ids: invitationIds.toString()
    }
  }
  return doRequestAxios(`/v2/workplace/invitations-from-entity/refuse`, requestOptions)
}

function updateRole(workplaceId, userIds, role, action) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      workplace_id: workplaceId,
      user_ids: userIds.toString(),
      role,
      action
    }
  }
  return doRequestAxios(`/v2/workplace/update-role`, requestOptions)
}

function getWorkplaceList(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
  return doRequestAxios(`/v2/workplace/settings/workplace-list`, requestOptions)
}

function inviteToWorkplace(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data
  }
  return doRequestAxios(`/v2/workplace/invitations/bulk`, requestOptions)
}

function getWorkplaceManageInvites(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
  return doRequestAxios(`/v2/workplace/settings/manage-invites`, requestOptions)
}

function getWorkplaceSettings(workplaceId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      workplace_id: workplaceId
    }
  }
  return doRequestAxios(`/v2/workplace/settings/display`, requestOptions)
}

function updateWorkplace(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data
  }
  return doRequestAxios(`/v2/workplace/update`, requestOptions)
}

function getWorkplaceGroups(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
  return doRequestAxios(`/v2/workplace/settings/groups`, requestOptions)
}

function getWorkplaceSettingsMembers(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
  return doRequestAxios(`/v2/workplace/settings/members`, requestOptions)
}

function getWorkplaceMembers(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
  return doRequestAxios(`/v2/workplace/members`, requestOptions)
}

function getLeadershipTeam(params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params
  }
  return doRequestAxios(`/v2/workplace/settings/leadership-team`, requestOptions)
}

function getRightsPermissions(workplaceId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      workplace_id: workplaceId
    }
  }
  return doRequestAxios(`/v2/workplace/settings/rights-permissions`, requestOptions)
}

function removeWorkplaceMember(data) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data
  }
  return doRequestAxios(`/v2/workplace/member/remove`, requestOptions)
}

function deleteWorkplace(data) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    data
  }
  return doRequestAxios(`/v2/workplace/delete`, requestOptions)
}

function deleteWorkplaceInvitation(data) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    data
  }
  return doRequestAxios(`/v2/workplace/invitation/delete`, requestOptions)
}

function getInvites(quantity, offset) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      offset,
      quantity
    }
  }
  return doRequestAxios(`/v2/workplace/invitations/me`, requestOptions)
}

function respondToInvite(answer, invitationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  if (answer === 'accept') {
    return doRequestAxios(`/v2/workplace/invitation/accept?invitation_id=${invitationId}`, requestOptions)
  } else if (answer === 'refuse') {
    return doRequestAxios(`/v2/workplace/invitation/refuse?invitation_id=${invitationId}`, requestOptions)
  }
}

function sendInviteToNonWPMembers(entityId, entityType, emails, message) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      entity_type: entityType,
      entity_id: entityId,
      emails,
      message
    }
  }
  return doRequestAxios('/v2/workplace/invitations-from-entity/send', requestOptions)
}
